export interface TeacherContentItem {
    title: string;
    content: string[];
}

/**
 * Demo content.
 *
 * The customer build listed a real teacher's degrees, the school they attended
 * and their exam ranking. A public demo must not carry a real person's CV, so
 * this describes what a tutor can do WITH the platform instead — which is also
 * what someone evaluating the product actually wants to read.
 */
const teacherDescription: TeacherContentItem[] = [
    {
        title: "ผู้สอนทำอะไรได้บ้าง",
        content: [
            "อัปโหลดวิดีโอบทเรียน จัดเป็นบท และกำหนดบทที่ให้ดูตัวอย่างได้ฟรี",
            "สร้างคลังข้อสอบเอง หรือให้ AI ช่วยออกข้อสอบตามวิชา ระดับชั้น และระดับความยาก",
        ],
    },
    {
        title: "ระบบช่วยดูแลผู้เรียนอย่างไร",
        content: [
            "ชุดข้อสอบสุ่มข้อจากคลัง ผู้เรียนแต่ละคนจึงไม่ได้ข้อเดียวกัน และทำซ้ำได้ไม่ซ้ำเดิม",
            "รายงานรายบุคคลบอกว่าผู้เรียนแต่ละคนอ่อนหัวข้อไหน โดยถ่วงน้ำหนักผลล่าสุดมากกว่าผลเก่า",
            "แนะนำหัวข้อที่ควรทบทวน พร้อมชุดฝึกเฉพาะเรื่องและลิงก์กลับไปดูวิดีโอบทนั้น",
            "ติดตามเวลาเรียนและความคืบหน้าได้ทั้งรายคนและทั้งคอร์ส",
        ],
    },
];

const teacherSpecialty: TeacherContentItem[] = [{
    title: "เหมาะกับใคร",
    content: [
        "สถาบันกวดวิชาที่ขายคอร์สวิดีโอและอยากดูแลผู้เรียนได้เป็นรายคน",
        "ติวเตอร์อิสระที่อยากมีคลังข้อสอบและรายงานผลของตัวเอง",
        "โรงเรียนที่อยากให้ผู้ปกครองติดตามความก้าวหน้าของนักเรียนได้",
    ]
}]

export { teacherSpecialty, teacherDescription };
